<template>
  <div>
    <v-chart :forceFit="true" :height="height" :data="data" :scale="scale">
      <v-tooltip />
      <v-axis />
      <v-bar  position="year*sales" />
    </v-chart>
  </div>
</template>

<script>
  export default {
      name: 'Bar',
      props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    scale: {
      type: Array,
      default: () => {
        return [{
          dataKey: 'x',
          min: 2
        }, {
          dataKey: 'y',
          title: '时间',
          min: 1,
          max: 22
        }]
      }
    },
    // tooltip: {
    //   type: Array,
    //   default: () => {
    //     return [
    //       'x*y',
    //       (x, y) => ({
    //         name: x,
    //         value: y
    //       })
    //     ]
    //   }
    // }
  },
    data() {
      return {
        height:400
      };
    }
  };
</script>